module.exports = __webpack_public_path__ + "img/BG.161fb4b8.png";